import React, { useEffect, useState } from 'react'
import { Article, ArticleMapping } from '../types/DataTypes'
import isObjectEmpty from '../utils/isObjectEmpty'
import { API } from '../utils/api'

export interface ArticlesContextInterface {
  articles: ArticleMapping
  eanArticleMapping: EANArticleMapping
  rawArticles: Article[]
  setArticles: (articles?: any) => any
  articlesAreLoading: boolean
}

interface EANArticleMapping {
  [ean: string]: Article
}

const ArticlesContext = React.createContext<ArticlesContextInterface>({
  articles: {},
  eanArticleMapping: {},
  rawArticles: [],
  setArticles: () => {},
  articlesAreLoading: false,
})

const ArticlesContextProvider = (props: any) => {
  const [articlesAreLoading, setArticlesAreLoading] = useState(false)
  const [articles, setArticles] = useState({})
  const [eanArticleMapping, setEanArticleMapping] = useState({})
  const [rawArticles, setRawArticles] = useState<Article[]>([])

  useEffect(() => {
    const fetchArticles = async () => {
      setArticlesAreLoading(true)
      const { items } = await API.get('its-items', '/', {})

      setRawArticles(items)
      setArticlesAreLoading(false)
    }

    if (isObjectEmpty(articles)) fetchArticles()

    return () => {}
  }, [articles])

  useEffect(() => {
    const newArticles = rawArticles.reduce((acc: any, article: any) => {
      acc[article.SKU] = article
      return acc
    }, {})
    const newEanArticleMapping = rawArticles.reduce((mapping: EANArticleMapping, article: Article) => {
      mapping[article.GTIN] = article
      return mapping
    }, {})
    setEanArticleMapping(newEanArticleMapping)
    setArticles(newArticles)
  }, [rawArticles])

  const value = React.useMemo(
    () => ({
      articles,
      rawArticles,
      eanArticleMapping,
      setArticles: (items: any) => {
        setRawArticles(items)
      },
      articlesAreLoading,
    }),
    [articles, rawArticles, eanArticleMapping, articlesAreLoading],
  )

  return <ArticlesContext.Provider value={value}>{props.children}</ArticlesContext.Provider>
}

export { ArticlesContextProvider, ArticlesContext }

export default ArticlesContext
